import React from 'react';
import { css } from 'styled-components';
import { Form } from 'react-final-form';
import { mustBeNumber, composeValidators } from 'validation/validators';
import i18n from 'i18n';
import CustomMedia from 'util/custom-media-query';
import { applyStyles } from 'util/helpers';
import BlockHeader from 'components/common/BlockHeader';
import FontStyles from 'constants/font-styles';
import Colors from 'constants/colors';
import TextField from 'components/common/TextField';
import Button from 'components/common/Button';
import Breadcrumbs from 'components/common/Breadcrumbs';
import MediaBorders from 'constants/media-borders';
import GrayHeader from 'components/common/GrayHeader';

class Login extends React.Component {
  constructor(prevProps) {
    super(prevProps);
    this.state = {
      init: false
    };
  }
  componentDidUpdate(prevProps) {
    // エラー時の処理
    if (this.props.error && prevProps.error == null) {
      const {
        showAlert,
        error: {
          data: { message }
        }
      } = this.props;
      showAlert(message);
    }
  }

  componentDidMount() {
    this.setState({
      init: true
    });
  }

  handleLogin = async ({ id, password }) => {
    const { login, push } = this.props;

    try {
      await login(id, password);
    } catch (error) {
      if (this.props.error) {
        const {
          showAlert,
          error: {
            data: { message }
          }
        } = this.props;
        return showAlert(message);
      }
    }

    sessionStorage.setItem('token', this.props.token);
    push('/mypage/history');
  };

  render() {
    const {
      className,
      location: { pathname }
    } = this.props;

    return (
      <div className={className}>
        <GrayHeader text={i18n.t('mypage:grayHeaderText')} />
        <Breadcrumbs currentPath={pathname} />
        <BlockHeader>{i18n.t('mypage:loginHeader')}</BlockHeader>
        <div className="notification">{i18n.t('mypage:loginDescription')}</div>
        <Form
          onSubmit={this.handleLogin}
          render={({ handleSubmit, submitting, hasValidationErrors }) => (
            <form className="login-form" onSubmit={handleSubmit}>
              <TextField
                name="id"
                type="tel"
                validate={value =>
                  !value
                    ? i18n.t('common:validationMessages.emptyOrderNumber')
                    : composeValidators(mustBeNumber)(value)
                }
                label={i18n.t('mypage:orderNumber') + '：'}
                maxLength={32}
              />
              <TextField
                name="password"
                type="password"
                validate={value =>
                  !value
                    ? i18n.t('common:validationMessages.emptyPassword')
                    : undefined
                }
                label={i18n.t('mypage:password') + '：'}
                maxLength={32}
              />
              <div className="submit">
                <Button
                  type="submit"
                  buttonType="A"
                  disabled={
                    !this.state.init || hasValidationErrors || submitting
                  }
                >
                  {i18n.t('mypage:checkFromOrderNumber')}
                </Button>
              </div>
            </form>
          )}
        />
      </div>
    );
  }
}

const commonStyle = css`
  margin: 0 auto;
  ${BlockHeader} {
    margin: 0 auto;
    text-align: center;

    &:after {
      left: 50%;
      transform: translate(-50%, 0);
    }
  }

  .notification {
    ${FontStyles.text8};
    color: ${Colors.black1};
    text-align: center;
  }

  .submit {
    text-align: center;
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  width: 100%;
  padding: 12px 160px 160px;
  margin: 104px auto 0;
  max-width: ${MediaBorders.large};

  ${BlockHeader} {
    width: 420px;
    margin-top: 32px;
  }

  .notification {
    width: 330px;
    margin: 32px auto;
  }

  .login-form {
    width: 382px;
    margin: 0 auto;

    ${TextField} {
      margin: 0 auto 36px;

      &:last-of-type {
        margin-bottom: 42px;
      }

      label {
        margin-bottom: 12px;
      }
    }
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  width: 100%;
  padding: 8px 16px 0;

  ${BlockHeader} {
    width: 310px;
    max-width: 100%;
    padding-bottom: 11px;
    margin-top: 24px;
  }

  .notification {
    width: 285px;
    margin: 20px auto 18px;
  }

  .login-form {
    width: 100%;
    margin: 0 auto;

    ${TextField} {
      padding: 0;
      margin: 0;

      label {
        margin-bottom: 8px;
      }

      &:first-of-type {
        margin-bottom: 28px;
      }
    }

    ${Button} {
      display: block;
      width: 100%;
      margin: 32px 0 48px;
    }
  }

`;

export default applyStyles(Login)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/Mypage/Login/index.js